import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71516169"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLoaderPage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/LoaderPage/LoaderPage.vue').default,HotHome: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Home/Home.vue').default})
